import { CollaborationState } from '@/signalr';

export type InvolvedPsapStateComponentProps = {
  collaborationState: CollaborationState;
  psapName: string;
};

function effectiveCssClass(collaborationState: CollaborationState): string | null {
  switch (collaborationState) {
    case CollaborationState.Requested:
      return 'bg-warning-subtle px-1 rounded-2';
    case CollaborationState.Confirmed:
      return 'bg-success-subtle px-1 rounded-2';
    case CollaborationState.Rejected:
      return 'bg-danger-subtle px-1 rounded-2';
    default:
      return null;
  }
}

function effectiveCollaborationStateIcon(collaborationState: CollaborationState): string | null {
  switch (collaborationState) {
    case CollaborationState.Requested:
      return 'fal fa-question-circle';
    case CollaborationState.Confirmed:
      return 'fal fa-check-circle';
    case CollaborationState.Rejected:
      return 'fal fa-times-circle';
    default:
      return null;
  }
}

export function InvolvedPsapStateComponent({ collaborationState, psapName }: InvolvedPsapStateComponentProps) {
  const icon = effectiveCollaborationStateIcon(collaborationState);

  return (
    <div className={effectiveCssClass(collaborationState) ?? ''}>
      <span>{psapName}</span>

      {icon !== null && <i className={`${icon} fa-sm ms-1`}></i>}
    </div>
  );
}
